import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ResetPasswordRequestType } from '../interfaces/auth';
import { AuthService } from '../services/auth.service';
import { AngularDIContext } from '../../injector/components/angular-di/di-context';
import AuthAPI from '../api/AuthAPI';
import { useHandleAuthResponse } from './useHandleAuthResponse';

export function useResetPassword() {
  const angularDIContext = useContext(AngularDIContext);
  const handleAuthResponse = useHandleAuthResponse();
  const { search } = useLocation();

  const next = new URLSearchParams(search).get('next');

  const resetPassword = (
    code: string,
    password: string,
    resetPasswordRequestType: ResetPasswordRequestType
  ) =>
    AuthAPI.resetPassword(code, password, resetPasswordRequestType).then(res => {
      handleAuthResponse(res, next || '');
      return res;
    });

  return {
    resetPassword
  };
}
